import axios from '../../../../untils/request.js'
//   企业中心道具管理-招聘道具列表
export async function sysPropsList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/sys/sysPropsList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//   获取相关道具价格
export async function getSysPropPrice (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/sys/getSysPropPrice',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//   道具购买价格计算
export async function calculateBuyPropPrice (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/sys/calculateBuyPropPrice',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

// 统一支付入参：data = { data: { businessType, payMethod, businessInfo: { priceId, count, useTraceCoin }, password? } }
// 精英卡：businessType=ELITE_CARD_BUY，payMethod=ALIPAY|WECHAT_PAY|TRACE_COIN_PAY_ELITE_CARD（/global/proxy/pay）
// 人才信用卡：businessType=CREDIT_CARD_BUY，payMethod=ALIPAY|WECHAT_PAY|TRACE_COIN_PAY_CREDIT_CARD（/info/pay）
// 商机信息卡：businessType=BUSINESS_INFO_CARD_BUY，payMethod=ALIPAY|WECHAT_PAY|TRACE_COIN_PAY_BUSINESS_INFO_CARD（/info/pay）
export async function pay (data, currentPage, pageSize) {
  const businessType = (data && data.data && data.data.businessType) || 'ELITE_CARD_BUY';
  const url = businessType === 'ELITE_CARD_BUY' ? '/global/proxy/pay' : '/info/pay';
  const res = await axios({
    method: 'post',
    url,
    intercept: 1,
    currentPage: currentPage || 1,
    pageSize: pageSize || 10,
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return res.data
}
// 查询道具详情，以及使用记录
export async function getPropDetailAndUsageLog (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/getPropDetailAndUsageLog',
    intercept: 1,
    currentPage,
    pageSize,
    data,
  })
  return res.data
}
// 获取vip权益列表
export async function vipInterests (data, currentPage, pageSize) {
  const res = await axios({
    method: 'get',
    url: '/global/company/vip/interests',
    intercept: 1,
    currentPage,
    pageSize,
    data,
  })
  return res.data
}
// 购买vip权益
export async function vipPay (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/proxy/pay',
    intercept: 1,
    currentPage,
    pageSize,
    data,
  })
  return res.data
}
// 计算到期时间
export async function calculateEndTime (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/vip/calculateEndTime',
    intercept: 1,
    currentPage,
    pageSize,
    data,
  })
  return res.data
}

// 获取vip等级
export async function getVipLevel (data, currentPage, pageSize) {
  const res = await axios({
    method: 'get',
    url: '/global/company/vip/getVipLevel',
    intercept: 1,
    currentPage,
    pageSize,
    data,
  })
  return res.data
}
// 计算升级价格
export async function calculateUpgradePrice (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/vip/calculateUpgradePrice',
    intercept: 1,
    currentPage,
    pageSize,
    data,
  })
  return res.data
}